import StopWatch from './stopwatch';
import './App.css';

function App() {
  return (
    <StopWatch/>
  );
}

export default App;
